import { HSLColor } from '@yola/yola-palette-generator';
import border from '../../border';

const light = (params) => {
  const { hue, saturation, lightness } = border.default.light(params);

  return new HSLColor(hue, saturation, lightness, 0);
};

export default light;
